import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Return = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Return" {...props}>
    <path d="M20 1C20.5523 1.00001 21 1.44772 21 2V12C21 14.7614 18.7614 17 16 17H6.37693L10.7041 21.29C11.0961 21.6789 11.0987 22.3119 10.7099 22.7041C10.3211 23.0962 9.68805 23.0987 9.29588 22.71L3.29588 16.7617C3.10777 16.5751 3.00121 16.3216 2.99998 16.0566C2.99883 15.7914 3.10329 15.536 3.29002 15.3477L9.29002 9.2959C9.67886 8.90382 10.3119 8.90125 10.7041 9.29004C11.0962 9.67888 11.0987 10.3119 10.7099 10.7041L6.45115 15H16C17.6568 15 19 13.6568 19 12V2C19 1.44772 19.4477 1.00001 20 1Z" fill="#000" />
  </StyledIcon>
));

Return.displayName = 'Return';

export { Return };
